export default defineNuxtRouteMiddleware((to, from) => {
  const organizationStore = useOrganizationStore();
  const subscriptionStore = useSubscriptionStore();

  if (!subscriptionStore.hasPlatformAccess) {
    return `/${organizationStore.organizationUrl}`;
  }
});
